import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from './Showcase';

const POINTS = [
  ['12-hr', 'built for the whole shift'],
  ['1 tap', 'from notes to SBAR'],
  ['0', 'accounts to create'],
];

export const Bedside = () => (
  <section className="lp-banner" data-testid="bedside-section">
    <motion.div
      className="lp-banner__frame"
      initial={{ opacity: 0, scale: 0.97 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    >
      <img
        src="/landing/nurses-using-app.webp"
        alt="Two nurses in navy scrubs smiling at the ShiftReady app on a phone in a hospital hallway"
        width="1024" height="556" data-testid="bedside-nurse-photo"
      />
      <div className="lp-banner__copy">
        <span className="lp-eyebrow lp-eyebrow--amber">Built for the bedside</span>
        <h2 className="lp-h2">Made for nurses, and for the way your floor actually runs.</h2>
      </div>
    </motion.div>
    <div className="lp-wrap lp-banner__below">
      <motion.p {...reveal(1)} className="lp-banner__lead">
        Check a patient, update your sheet and hand off in the hallway, without hunting for the folded paper in your pocket.
      </motion.p>
      <motion.ul {...reveal(2)} className="lp-banner__stats">
        {POINTS.map(([big, small], i) => (
          <li key={big} data-testid={`bedside-stat-${i + 1}`}><strong>{big}</strong><span>{small}</span></li>
        ))}
      </motion.ul>
    </div>
  </section>
);
